module.exports = __webpack_public_path__ + "media/images/btn_icon_header_login_sp-7ad771f5e959b4664d8d62117a02ffa8.png";